"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function matic(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M17.0922 8.69345C16.7232 8.47781 16.2435 8.47781 15.8377 8.69345L12.9594 10.3467L11.0037 11.425L8.12546 13.0782C7.75645 13.2939 7.27675 13.2939 6.87085 13.0782L4.58303 11.7843C4.21402 11.5687 3.95572 11.1734 3.95572 10.7421V8.19028C3.95572 7.75899 4.17712 7.36364 4.58303 7.14799L6.83394 5.89007C7.20295 5.67442 7.68265 5.67442 8.08855 5.89007L10.3395 7.14799C10.7085 7.36364 10.9668 7.75899 10.9668 8.19028V9.84356L12.9225 8.72939V7.07612C12.9225 6.64482 12.7011 6.24947 12.2952 6.03383L8.12546 3.66173C7.75645 3.44609 7.27675 3.44609 6.87085 3.66173L2.62731 6.03383C2.2214 6.24947 2 6.64482 2 7.07612V11.8563C2 12.2875 2.2214 12.6829 2.62731 12.8986L6.87085 15.2706C7.23984 15.4863 7.71956 15.4863 8.12546 15.2706L11.0037 13.6533L12.9594 12.5391L15.8377 10.9218C16.2066 10.7061 16.6863 10.7061 17.0922 10.9218L19.3432 12.1797C19.7121 12.3954 19.9704 12.7907 19.9704 13.222V15.7738C19.9704 16.2051 19.7491 16.6004 19.3432 16.8161L17.0922 18.11C16.7232 18.3256 16.2435 18.3256 15.8377 18.11L13.5867 16.852C13.2177 16.6364 12.9594 16.241 12.9594 15.8097V14.1565L11.0037 15.2706V16.9239C11.0037 17.3552 11.2251 17.7505 11.631 17.9662L15.8745 20.3383C16.2435 20.5539 16.7232 20.5539 17.1291 20.3383L21.3727 17.9662C21.7417 17.7505 22 17.3552 22 16.9239V12.1437C22 11.7125 21.7786 11.3172 21.3727 11.1015L17.0922 8.69345Z", fill: color }));
}
exports["default"] = matic;
//# sourceMappingURL=matic.js.map